import { Cart, CartItem } from '../../types'

export const getCartProductsCodes = (cart: Cart): string[] => {
  return cart
    ? cart.items.map((item: CartItem): string => item.product.code)
    : []
}
